import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { buildPlaceUrls, contract, formatPlaceName, } from '@aviv_price-pages/brand';
import { Box } from '@gemini/core';
import { Link } from '@/components/Link';
import { MediumCta } from '@/entities/enums/MediumCta';
import { getMediumAttribute } from '@/helpers/tracking/tracking';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
export const HouseNumbersList = ({ places, currentPlace, }) => {
    const { t } = useShellTranslation();
    const [data, setData] = useState();
    useEffect(() => {
        const fetchData = async () => {
            const resolvedData = await Promise.all(places.map(async (place) => ({
                url: (await buildPlaceUrls(contract.nameAbbreviation, [place]))[0],
                name: formatPlaceName(place, { isShortName: true }),
                type: place.type,
            })));
            setData(resolvedData);
        };
        fetchData();
    }, [places]);
    return (_jsxs(Box, { as: "div", minWidth: "220px", children: [_jsx(Box, { as: "h3", margin: "spacing.4", children: t('map_view.address_search_list.title') }), _jsx(Box, { as: "div", maxHeight: "240px", minWidth: "220px", overflow: "auto", children: data?.map((place) => (_jsx(Box, { as: "div", margin: "spacing.2", children: _jsx(Link, { href: place.url, mediumAttribute: getMediumAttribute(MediumCta.MAP, currentPlace.type, place.type), children: place.name }) }, place.name))) })] }));
};
